<template>
  <div class="first">
    <div class="con"></div>
    <div ref="video_wrap" class="video_wrap">
      <video
        ref="videos"
        class="videos"
        autoplay
        muted
        loop
        preload="auto"
        poster="@/assets/images/poster.jpg"
      >
        <source src="@/assets/video/xrkl.mp4" type="video/mp4" />
        您的浏览器不支持video标签
      </video>
    </div>
    <div class="word">
      <div class="container">
        <img
          :class="['xthk-word', activeIndex === 0 ? 'animated fadeInUp ' : '']"
          src="@/assets/images/xthk-1.png"
          alt
        />
        <p class="desc" :class="activeIndex === 0 ? 'animated fadeInUp' : ''">
          心田花开是一家以“情商语文”为核心，秉承良心教育理念、坚持体系教学模式，致力于用科技手段服务教育的综合性教育科技集团。旗下包括本地面授、本地双师、本地网校、全国网校等事业部。
        </p>
        <div
          class="more"
          :class="activeIndex === 0 ? 'animated fadeInUp' : ''"
          @click="toAbout()"
        >
          了解更多
        </div>

        <img
          :class="[
            'down',
            show ? 'jump' : '',
            activeIndex === 0 ? 'animated fadeInUp ' : ''
          ]"
          src="@/assets/images/down.png"
          @click="$emit('jump')"
        />
      </div>
    </div>
  </div>
</template>
<script>
import '@/utils/bideo.js';
export default {
  props: ['swiper'],
  data() {
    return {
      show: false //向下箭头是否显示
    };
  },
  computed: {
    activeIndex() {
      return this.$store.state.activeIndex;
    }
  },
  mounted() {
    this.bvInit();
    this.showIcon();
    this.getWidth();
    //监听浏览器宽度的改变
    window.addEventListener('resize', this.getWidth);
  },
  destroyed() {
    window.removeEventListener('resize', this.getWidth);
  },
  methods: {
    toAbout() {
      this.$router.push('/about');
    },
    bvInit() {
      var bv = new window.Bideo(); //新建一个 Bideo实例
      bv.init({
        videoEl: this.$refs.videos, //这个是video标签，放视频链接的地方
        container: this.$refs.video_wrap, //这个是video的父元素，
        resize: true //视频是否随着窗口变化而变化，必须是true;
      });
    },
    showIcon() {
      this.activeIndex === 0
        ? setTimeout(() => {
            this.show = true;
          }, 3000)
        : '';
    },
    // 设置视频宽度
    getWidth() {
      this.$refs.videos.style.width = document.body.clientWidth + 'px';
    }
  }
};
</script>
<style lang="less">
.first {
  height: 100vh;
  width: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  .con {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
    background: rgba(0, 0, 0, 1);
    opacity: 0.4;
    height: 100%;
    width: 100%;
    filter: alpha(opacity=60);
  }
  .video_wrap {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 8;
  }
  .videos {
    object-fit: fill;
  }
  .word {
    width: 100vw;
    position: relative;
    z-index: 10;
    height: 100vh;
    .container {
      height: 55%;

      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      margin-top: 10%;
      text-align: center;
    }
  }
  p {
    margin: 0;
    padding: 0;
  }
  .desc {
    width: 100%;
    font-size: 24px;
    font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    line-height: 41px;
    color: rgba(255, 255, 255, 1);
    opacity: 0.9;
    animation-delay: 0.3s;
    word-wrap: break-word;
    word-break: normal;
  }

  .more {
    cursor: pointer;
    background: rgba(255, 173, 28, 1);
    opacity: 1;
    border-radius: 50px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    animation-delay: 0.6s; //动画延迟，上一个结束才执行;
  }
  .down {
    cursor: pointer;
    animation-delay: 0.9s;
  }
  .jump {
    animation: jumps 2s linear infinite;
  }
  @keyframes jumps {
    25% {
      transform: translateY(-10px);
    }
    50%,
    100% {
      transform: translateY(0);
    }
    75% {
      transform: translateY(10px);
    }
  }
}
</style>
